/**
 * Calculates hours and minutes components from total minutes.
 * 
 * @param {number | null | undefined} totalMinutes - The total number of minutes to convert
 * @returns {{ hours: number; minutes: number }} An object containing the hours and minutes components
 * 
 * @example
 * // Convert 150 minutes to hours and minutes
 * const time = calculateTimeFromMinutes(150);
 * console.log(time); // Outputs: { hours: 2, minutes: 30 }
 * 
 * @example
 * // Handle null/undefined input
 * const time = calculateTimeFromMinutes(null);
 * console.log(time); // Outputs: { hours: 0, minutes: 0 }
 */
export function calculateTimeFromMinutes(
  totalMinutes: number | null | undefined
): { hours: number; minutes: number } {
  // Handle invalid inputs
  if (totalMinutes === undefined || totalMinutes === null || Number.isNaN(totalMinutes)) {
    return { hours: 0, minutes: 0 };
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return { hours, minutes };
} 